import { booleanColumn } from '@/shared/grids/columns/booleanColumn';
import { GridColumnSettings } from '@/shared/types/grid';

export const amlConnectedColumn = <T>(options: { uid?: string; field: keyof T & string }): GridColumnSettings<T> => {
  const { uid, field } = options;

  return booleanColumn({
    uid,
    field,
    header: 'AML Connected',
    iconClass: 'fa-solid fa-user-shield',
    allowFiltering: false,
    visible: false,
    chooserName: 'AML Connected ( <i class="fa-solid fa-user-shield text-primary"></i> )',
  });
};
